import "./css/IntroPage.css";
import Brand1 from "./img/Brands/microsoft.jpg";
import Brand2 from "./img/Brands/client2.jpg";
import Brand4 from "./img/Brands/client1.jpg";
import Brand6 from "./img/Brands/client5.jpg";
import Brand7 from "./img/Brands/servicenow.png";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake } from '@fortawesome/free-solid-svg-icons';

const CompanyAndProduct = () => {
  const brands = [Brand7, Brand1, Brand4, Brand6, Brand2];
  const EVENT_URL = "tinyurl.com/SNAIDC25";
  return (

    <div className="brand-container">
      <div className="brand-width brand-flex">
        {/* <div className="brand-title-container">
          <FontAwesomeIcon icon={faHandshake} className="brand-title brand-icon" />
          <div className="brand-title">Partners</div>
        </div> */}
        <div className="brand-title-container">

          <div className="brand-title">Partners</div>
          <FontAwesomeIcon icon={faHandshake} className="brand-title brand-icon" />
        </div>

        {brands.map((item, index) => (
          <>
            <div className="brand-item" key={index}>
              <img src={item} className="brand-img" />
            </div>
          </>
        ))}
      </div>

    </div>

  );
};

export default CompanyAndProduct;
